import { serverAjaxPromise } from './request_helpers';

const retrievePrintedGift = (id, locale) => {
  const headers = locale ? { 'X-Language-Locale': locale } : {};
  return serverAjaxPromise({
    type: 'POST',
    contentType: 'application/json',
    headers,
    url: '/api/private/coupon',
    data: JSON.stringify({ coupon_id: id }),
    resReducer: resp => resp
  });
};

export { retrievePrintedGift };
